import { endOfMonth, endOfWeek, endOfYear, format, formatDistance, parseISO, startOfMonth, startOfWeek, startOfYear } from 'date-fns';

export const today = () => new Date().toISOString().substring(0, 10);
export const yesterday = () => {
  const _today = new Date();
  _today.setDate(_today.getDate() - 1);
  return selectedFormat(_today);
};

export const getFirstAndLastWeekDays = (date: string = today()) => ({
  from: selectedFormat(startOfWeek(new Date(date), { weekStartsOn: 1 })),
  to: selectedFormat(endOfWeek(new Date(date), { weekStartsOn: 1 })),
});

export const getFirstAndLastMonthDays = (currentDate: string = today()) => ({
  from: selectedFormat(startOfMonth(new Date(currentDate))),
  to: selectedFormat(endOfMonth(new Date(currentDate))),
});

export const getFirstAndLastYearDays = (currentDate: string = today()) => ({
  from: selectedFormat(startOfYear(new Date(currentDate))),
  to: selectedFormat(endOfYear(new Date(currentDate))),
});

export const selectedFormat = (date: Date) => {
  const month = (date.getMonth() + 1) <= 9 ? `0${date.getMonth() + 1}` : (date.getMonth() + 1).toPrecision();
  const day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate().toPrecision();
  return `${date.getFullYear()}-${month}-${day}`;
};

export const selectedFormatISO = (date: Date) => {
  return date.toISOString().substring(0, 10);
};

export const agoFormat = (value?: number) => {
  if (value === undefined) {
    return;
  }

  return formatDistance(new Date(value), new Date(), { addSuffix: true });
};

/** offset -> hour * 4 */
export const getTimeRemoveAndApplyOffset = (date: number, offset?: number | string) => {
  if (offset === undefined || offset === null) {
    return new Date(date * 1000);
  }

  const _offset = Number(offset) / 4;
  const _date = new Date(date * 1000);
  _date.setHours(_date.getHours() + _date.getTimezoneOffset() / 60);
  _date.setHours(_date.getHours() + _offset);
  return _date;
};

export const getTimeApplyOffset = (date: number, offset?: number | string) => {
  if (offset === undefined || offset === null) {
    return new Date(date * 1000);
  }

  const _offset = Number(offset) / 4;
  const _date = new Date(date * 1000);
  _date.setHours(_date.getHours() + _offset);
  return _date;
};

export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const formatHour = (value: string) => format(parseISO(value), 'HH:mm');
export const formatDate = (value: string) => format(parseISO(value), 'yyyy-MM-dd');

export type MinutesDurationUnitLabels = {
  days: string;
  hours: string;
  minutes: string;
};

export const formatMinutesDuration = (
  minutes: number | null,
  unitLabels?: Partial<MinutesDurationUnitLabels>
) => {
  if (minutes === null || Number.isNaN(minutes)) {
    return '';
  }
  const labels: MinutesDurationUnitLabels = {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    ...unitLabels,
  };
  const totalMinutes = Math.max(0, Math.floor(minutes));
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const mins = totalMinutes % 60;
  const parts = [];
  if (days) {
    parts.push(`${days}${labels.days}`);
  }
  if (hours) {
    parts.push(`${hours}${labels.hours}`);
  }
  if (mins || parts.length === 0) {
    parts.push(`${mins}${labels.minutes}`);
  }
  return parts.join(' ');
};

export const formatCountdown = (totalSeconds: number | null): string => {
  if (totalSeconds === null || totalSeconds < 0) {
    return '--:--';
  }
  const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
  const seconds = Math.floor(totalSeconds % 60).toString().padStart(2, '0');
  return `${minutes}:${seconds}`;
};
